"use strict"
exports.__esModule = true;
exports.SmileWinkIconConfig = {
  name: 'SmileWinkIcon',
  height: 512,
  width: 496,
  svgPath: 'M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z',
  yOffset: 0,
  xOffset: 0,
};
exports.SmileWinkIcon = require('../createIcon').createIcon(exports.SmileWinkIconConfig);
exports["default"] = exports.SmileWinkIcon;